type SmoothScrollOptions = {
  duration?: number;
  offset?: number;
};

function easeInOutCubic(progress: number): number {
  return progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - Math.pow(-2 * progress + 2, 3) / 2;
}

export function smoothScrollToElement(
  element: HTMLElement,
  { duration = 1000, offset = 0 }: SmoothScrollOptions = {},
) {
  const startY = window.scrollY;
  const targetY = startY + element.getBoundingClientRect().top - offset;
  const distance = targetY - startY;

  if (Math.abs(distance) < 2) return;

  const startTime = performance.now();

  function step(currentTime: number) {
    const progress = Math.min((currentTime - startTime) / duration, 1);

    window.scrollTo(0, startY + distance * easeInOutCubic(progress));

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}
